module.exports = __webpack_public_path__ + "static/media/group_97.0e83923a.png";